import { useEffect } from 'react';
import useSWR from 'swr';
import { SWR_KEYS } from 'constants/constants';
import { countriesList } from 'services/countriesList';
import { ICountryDetail } from 'types/countries';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

/**
 * Obtiene el listado de países con cache vía SWR.
 */
export function useListCountries() {
  const {
    data: countries,
    error: countriesError,
    isLoading,
    mutate: mutateCountriesList
  } = useSWR<ICountryDetail[]>(SWR_KEYS.listCountries, () => countriesList(), {
    revalidateOnFocus: false
  });

  const areCountriesLoading = isLoading && countries === undefined;

  useEffect(() => {
    if (countriesError && countries === undefined) {
      displayErrorNotification();
    }
  }, [countriesError, countries]);

  return { countries, countriesError, areCountriesLoading, mutateCountriesList };
}
